export default "__VITE_ASSET__BDgAcXS5__"